"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _rtl = require("../../../utils/rtl");

var _defaultTheme = _interopRequireDefault(require("../../../defaultTheme"));

var StyledButtonPrimitiveContentChildren = _styledComponents.default.div.withConfig({
  displayName: "ButtonPrimitiveContentChildren__StyledButtonPrimitiveContentChildren",
  componentId: "xn0ytv-0"
})(["display:inline-block;width:", ";text-align:", ";"], function (_ref) {
  var contentWidth = _ref.contentWidth;
  return contentWidth;
}, function (_ref2) {
  var hasIcon = _ref2.hasIcon;
  return hasIcon && _rtl.left;
}); // $FlowFixMe: https://github.com/flow-typed/flow-typed/issues/3653#issuecomment-568539198


StyledButtonPrimitiveContentChildren.defaultProps = {
  theme: _defaultTheme.default
};

var ButtonPrimitiveContentChildren = function ButtonPrimitiveContentChildren(_ref3) {
  var children = _ref3.children,
      hasIcon = _ref3.hasIcon,
      contentWidth = _ref3.contentWidth;
  return /*#__PURE__*/React.createElement(StyledButtonPrimitiveContentChildren, {
    hasIcon: hasIcon,
    contentWidth: contentWidth
  }, children);
};

var _default = ButtonPrimitiveContentChildren;
exports.default = _default;